import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "informed";
import StatusHeader from "../common/status-header/StatusHeader";
import EditPassword from "../common/form-fields/edit-text/EditPassword";
import { updateResetPassword, resetUserPasswordInfo } from "../../api/auth-api";
import Loader from "../common/loader/Loader";
import ErrorView from "../common/error-view/ErrorView";
import "./ResetPasswordPage.css";

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changePasswordCompleted: false,
            fetching: false,
            changePasswordError: false,
            formApi: null,
            tokenValid: null, // To store if token is valid or not
            tokenExpired: false, // New state to track if token is expired
        };
        this.errorMessage = "";
        this.token = "";
        //For google analytics
        window.dataLayer.push({
            'event': 'Pageview',
            'url': window.location.pathname
        });
    }

    setFormApi = (formApi) => {
        this.setState({ formApi });
    };
    componentDidMount() {
        window.scrollTo(0, 0);
        // Extract token from URL query string
        const urlParams = new URLSearchParams(window.location.search);
         this.token = urlParams.get('token');

        if (this.token) {
            // Call the API with the token
            this.validateToken(this.token);
        }
        else {
            this.errorMessage = "The reset password link is either invalid or expired. Please generate a new link using the forgot password option."
            this.setState({
                fetching: false,
                changePasswordError: true,
                tokenExpired: true // Set tokenExpired state to true

            });
        }
    }

    validateToken = (token) => {
        this.setState({ fetching: true });

        resetUserPasswordInfo(token)
            .then((data) => {
                // If token is valid, proceed with the form
                if (data.ErrorSubCode === "Expired") {
                    this.errorMessage = "The reset password link is either invalid or expired. Please generate a new link using the forgot password option."
                    this.setState({
                        fetching: false,
                        changePasswordError: true,
                         tokenExpired: true
                       
                    });
                }
                else if (data.ErrorSubCode === "InvalidObject") {
                    this.errorMessage = "Could not reset your password. Please try later.";
                    this.setState({
                        fetching: false,
                        changePasswordError: false,
                        tokenExpired: true

                    });
                } 
                else {
                    this.setState({
                        tokenValid: true,
                        fetching: false,
                    });
                }
               
            })
            .catch((error) => {
                this.errorMessage = error.errorMessage
                    ? error.errorMessage
                    : "Could not change your password. Please try later.";
                this.setState({
                    fetching: false,
                    changePasswordError: false,
                    tokenExpired: true
                });
                window.scrollTo(0, 0);
            });
    };

    changePasswordHandler = (confirmPassword, password) => {
        // Validate Password
        this.setState({
            fetching: true,
            changePasswordError: false
        });

        updateResetPassword(confirmPassword, this.token)
            .then(response => {
                if (response.ErrorSubCode === "Expired") {
                    this.errorMessage = "The reset password link has expired. Please generate a new link using the forgot password option.";
                    this.setState({
                        fetching: false,
                        changePasswordError: false,
                        tokenExpired: true

                    });
                } 
                else if (response.ErrorSubCode === "InvalidObject") {
                    this.errorMessage = "Could not reset your password. Please try later.";
                    this.setState({
                        fetching: false,
                        changePasswordError: false,
                        tokenExpired: true // Set tokenExpired state to true

                    });
                } 
                else {
                   // store.dispatch(setChangePassword(false));
                    this.setState({
                        fetching: false,
                        changePasswordCompleted: true
                    });
                    //For google analytics
                    window.dataLayer.push({
                        'event': 'Pageview',
                        'url': window.location.pathname + '/Confirm'
                    });
                }
            })
            .catch(error => {
                this.errorMessage = error.errorMessage
                    ? error.errorMessage
                    : "Could not reset your password. Please try later.";
                this.setState({
                    fetching: false,
                    changePasswordError: false,
                    tokenExpired: true 
                });
                window.scrollTo(0, 0);
            });

    };
    render() {
        //const isCompleted = this.state.changePasswordCompleted;
        const { changePasswordCompleted, tokenExpired } = this.state;

        return (
            <React.Fragment>
                {tokenExpired ? (
                    <div>
                        <div id="dropdown-navmenu" className="container-fluid">
                            <div className="dropdown-navmenu-group d-flex container">
                            </div>
                            <div className="logo-container resetpassword-logo">
                                <img
                                    id="logo"
                                    alt="Healthy Paws Pet Insurance"
                                    src="../../assets/images/login/logo_main.png"
                                />
                            </div></div>
                        <div className="container margin-top17">
                            <div className="d-flex flex-column change-password">
                                <ErrorView>{this.errorMessage}</ErrorView>
                                <div class="button-container">
                                    <button
                                        type="submit"
                                        id="create_reset_button"
                                        className="button-primary forgot-Password-container btn-reset-height"
                                        onClick={() => {
                                            const params = new URLSearchParams({ page: 'forgot' });
                                            window.location.href = `/login?${params.toString()}`;
                                        }}
                                    >
                                        Forgot Password
                                    </button>
                                    <label
                                        className="button-link_cancel col-sm-12 col-md-2 button-margin"
                                        id="cancel_button"
                                        onClick={() => (window.location.href = '/')}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Back to Sign-In
                                    </label>
                                </div>
                                

                            </div>
                            {this.props.fetching && <Loader position="absolute" fullPage={true} />}
                        </div>
                    </div>
                   
                ) : (
                    // If not expired, show the password reset form
                    !changePasswordCompleted ? (
                        <UpdatePasswordForm
                            fetching={this.state.fetching}
                            submitHandler={(password, newPassword) => {
                                this.changePasswordHandler(password, newPassword);
                            }}
                            //changePasswordError={this.state.changePasswordError}
                            errorMessage={this.errorMessage}
                            backToHome={() => {
                                window.location.href = '/';
                            }}
                            setFormApi={this.setFormApi}
                        />
                    ) : (
                       
                           <div>
                        <div id="dropdown-navmenu" className="container-fluid">
                            <div className="dropdown-navmenu-group d-flex container">
                            </div>
                            <div className="logo-container resetpassword-logo">
                                <img
                                    id="logo"
                                    alt="Healthy Paws Pet Insurance"
                                    src="../../assets/images/login/logo_main.png"
                                />
                            </div></div>
                                    <div className="content-container">
                                            <PasswordChangeSuccess
                                                backToHome={() => {
                                                    this.props.history.push("/");
                                                }}
                                            />
                            {this.props.fetching && <Loader position="absolute" fullPage={true} />}
                        </div>
                    </div>
                    )
                )}
            </React.Fragment>
        );
    }
}

class UpdatePasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNote: false,
            showError: false
        };
    }

    passwordNote = password => {
        return (
            <div className="password-note d-flex">
                <i className="fa fa-question-circle-o" />
                <div>
                    <span>Password must:</span>
                    <br />
                    <span>
                        <i
                            className={
                                "fa " +
                                (this.validateLength(password)
                                    ? "fa-check-circle"
                                    : "fa-info-circle")
                            }
                        />{" "}
                        Be at least 8 characters long
                    </span>
                    <br />
                    <span>
                        <i
                            className={
                                "fa " +
                                (this.validateCharacter(password)
                                    ? "fa-check-circle"
                                    : "fa-info-circle")
                            }
                        />{" "}
                        Have at least 1 letter
                    </span>
                    <br />
                    <span>
                        <i
                            className={
                                "fa " +
                                (this.validateNumber(password)
                                    ? "fa-check-circle"
                                    : "fa-info-circle")
                            }
                        />{" "}
                        Have at least 1 number
                    </span>
                    <br />
                    <span>
                        <i
                            className={
                                "fa " +
                                (this.validateSpecialChar(password)
                                    ? "fa-check-circle"
                                    : "fa-info-circle")
                            }
                        />{" "}
                        Have at least 1 special character
                    </span>
                    <br />
                    <span>
                        <i
                            className={
                                "fa " +
                                (this.validateCase(password)
                                    ? "fa-check-circle"
                                    : "fa-info-circle")
                            }
                        />{" "}
                        Have at least 1 uppercase and 1 lowercase
                    </span>
                </div>
            </div>
        );
    };

    showHideNote = shouldShow => {
        this.setState({
            showNote: shouldShow
        });
    };

    showHideError = shouldShow => {
        this.setState({
            showError: shouldShow
        });
    };

    validateNewPassword = password => {
        if (!password) {
            return;
        }
        // validate length
        if (!this.validateLength(password)) {
            return "Password must be at least 8 characters long";
        }
        // contain a letter
        if (!this.validateCharacter(password)) {
            return "Password must have at least 1 letter";
        }
        // contain a number
        if (!this.validateNumber(password)) {
            return "Password must have at least 1 number";
        }
        // contain a special char
        if (!this.validateSpecialChar(password)) {
            return "Password must have at least 1 special character";
        }
        // contain a uppercase and lowercase
        if (!this.validateCase(password)) {
            return "Password must have at least 1 uppercase and 1 lowercase";
        }
        return null;
    };

    validateLength = password => {
        return password && password.trim().length > 7;
    };

    validateCharacter = password => {
        return password && /[a-zA-Z]/.test(password);
    };

    validateNumber = password => {
        return password && /\d/.test(password);
    };

    validateSpecialChar = password => {
        return password && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    };
    validateCase = password => {
        const hasUppercase = /[A-Z]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        return hasUppercase && hasLowercase && password;
    };

    setFormApi = api => {
        this.setState({
            formApi: api
        });
    };
    render() {

        return (
            <div>
            <div id="dropdown-navmenu" className="container-fluid">
                <div className="dropdown-navmenu-group d-flex container">
                   </div>
                    <div className="logo-container resetpassword-logo">
                        <img
                            id="logo"
                            alt="Healthy Paws Pet Insurance"
                            src="../../assets/images/login/logo_main.png"
                        />
                    </div></div>
            <div className="container">
                <div className="d-flex flex-column align-items-center justify-content-center change-password">
                        <h1 className="title-container d-flex align-items-center">
                    Reset Password
                    </h1>
                    {this.props.changePasswordError && (
                            <div className="container margin-top17">
                                <div className="d-flex flex-column change-password">
                                    <ErrorView>{this.errorMessage}</ErrorView>
                                    <div class="button-container">
                                        <button
                                            type="submit"
                                            id="create_reset_button"
                                            className="button-primary forgot-Password-container btn-reset-height"
                                            onClick={() => {
                                                const params = new URLSearchParams({ page: 'forgot' });
                                                window.location.href = `/login?${params.toString()}`;
                                            }}
                                        >
                                            Forgot Password
                                        </button>
                                        <label
                                            className="button-link_cancel col-sm-12 col-md-2 button-margin"
                                            id="cancel_button"
                                            onClick={() => (window.location.href = '/')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Back to Sign-In
                                        </label>
                                    </div>


                                </div>
                                {this.props.fetching && <Loader position="absolute" fullPage={true} />}
                            </div>
                    )}
                    <span style={{ marginBottom: '9px' }}>Enter a new password in the field below.</span>

                        <Form onSubmit={values => this.props.submitHandler(values.confirmPassword, values.password)}
                        getApi={(api) => {
                            this.setFormApi(api);
                            if (this.props.setFormApi) {
                                this.props.setFormApi(api);
                            }
                        }}
                        className="d-flex flex-column align-items-center justify-content-center" >
                        {({ formState, formApi }) => (
                                <React.Fragment>
                                    <EditPassword
                                        id="change_password_field"
                                        required
                                        field="password"
                                        type="password"
                                        title="New Password"
                                        floatingTitle={true}
                                        secured={true}
                                        validateOnBlur
                                        showError={this.state.showError}
                                        validate={this.validateNewPassword}
                                        onFocus={() => {
                                            this.showHideNote(true);
                                        }}
                                        onBlur={() => {
                                            this.showHideNote(false);
                                        }}
                                        onChange={event => {
                                            formApi.setError("password", null);
                                        }}
                                        note={
                                            this.state.showNote
                                                ? this.passwordNote(formState.values.password)
                                                : null
                                        }
                                        disabled={this.props.fetching}
                                        className="field-width"
                                    />
                                    <EditPassword
                                        id="confirm_password_field"
                                        field="confirmPassword"
                                        type="password"
                                        title="Confirm Password"
                                        floatingTitle={true}
                                        secured={true}
                                        validateOnBlur
                                        showError={this.state.showError}
                                        validate={value => {
                                            if (formState.values.password !== value) {
                                                return "New Password and Confirm Password must match";
                                            }
                                            return null;
                                        }}
                                        onFocus={() => {
                                            this.showHideNote(false);
                                        }}
                                        onChange={event => {
                                            formApi.setError("confirmPassword", null);
                                        }}
                                        disabled={this.props.fetching}
                                        className="field-width"
                                    />

                              
                                <div className="d-flex flex-column align-items-center justify-content-center button-container-margin">
                                    <button
                                        id="change_password_button"
                                            className="button-primary field-width btn-reset-height"
                                        type="submit"
                                        disabled={this.props.fetching}
                                    >
                                        Reset Password
                                    </button>

                                    <a href={window.location.origin} id="back_to_signin_button"
                                        className="mt-3"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Back to Sign-In
                                    </a>
                                </div>
                            </React.Fragment>
                        )}
                    </Form>
                </div>
                {this.props.fetching && <Loader position="absolute" fullPage={true} />}
                </div>
            </div>
         
        );
    }
}

const PasswordChangeSuccess = props => {
    return (
        <div className="password-change-success " style={{ width: '100%', marginTop: '-76px' }} >
                        <StatusHeader className="status">
                            <div className="d-inline-flex align-items-center status">
                                <i className="fa fa-check-circle align-middle" />
                                <div className="status-info">Success!</div>
                                <div className="d-none d-md-block status-text">
                                    &nbsp;Your account password has been changed.
                                </div>
                            </div>
                        </StatusHeader>
                        <div className="content container">
                            <h1 className="my-3 my-lg-0">Thank you!</h1>
                            <button
                                className="button-primary password-change-success-home-button mb-3 d-md-none d-block"
                                type="submit"
                                onClick={window.location.href = '/'}
                            >
                                Continue to Sign-In
                            </button>
                            <button
                                className="button-primary password-change-success-home-button mb-3 d-none d-md-block"
                                type="submit"
                                onClick={window.location.href = '/'}
                            >
                            Continue to Sign-In
                            </button>
                        </div>
                    </div>
    );
};

export default withRouter(ResetPasswordPage);
